import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api/super-admin';

// Create a separate axios instance for super admin
const superAdminAxios = axios.create({
  baseURL: API_BASE,
});

// Request interceptor for super admin
superAdminAxios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('superAdminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for super admin
superAdminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect on login failures - let the login page handle the error
    const isLoginRequest = error.config?.url === '/login';
    
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('superAdminToken');
      localStorage.removeItem('superAdmin');
      window.location.href = '/super-admin/login';
    }
    return Promise.reject(error);
  }
);

export const superAdminApi = {
  // Auth
  login: (email, password) => superAdminAxios.post('/login', { email, password }),
  getCurrentAdmin: () => superAdminAxios.get('/me'),

  // Stats
  getStats: () => superAdminAxios.get('/stats'),

  // Plans
  getPlans: () => superAdminAxios.get('/plans'),
  createPlan: (data) => superAdminAxios.post('/plans', data),
  updatePlan: (id, data) => superAdminAxios.put(`/plans/${id}`, data),

  // Tenants
  getTenants: (params) => superAdminAxios.get('/tenants', { params }),
  getTenant: (id) => superAdminAxios.get(`/tenants/${id}`),
  createTenant: (data) => superAdminAxios.post('/tenants', data),
  updateTenant: (id, data) => superAdminAxios.put(`/tenants/${id}`, data),
  suspendTenant: (id) => superAdminAxios.post(`/tenants/${id}/suspend`),
  activateTenant: (id) => superAdminAxios.post(`/tenants/${id}/activate`),
  deleteTenant: (id) => superAdminAxios.delete(`/tenants/${id}`),
  
  // Tenant Users
  getTenantUsers: (tenantId) => superAdminAxios.get(`/tenants/${tenantId}/users`),
  createTenantAdmin: (tenantId, data) => superAdminAxios.post(`/tenants/${tenantId}/create-admin`, data),
};

export default superAdminApi;
